// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { ProjectHeader, Project } from "./types";

// Define a service using a base URL and expected endpoints
export const khoziApi = createApi({
  reducerPath: 'khoziApi',

  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {          
        headers.set('Authorization', `Token ${localStorage.getItem("token")}`);
        return headers;
    }, 
  }),
  
  endpoints: (builder) => ({
    getProjects: builder.query<ProjectHeader[], void>({
      query: () => `/project/projects/`,
    }),
    getProjectById: builder.query<Project, number>({
      query: (id) => `/project/projects/${id}/get-project-by-id/`,
    }),
    addProject: builder.mutation<ProjectHeader, Partial<ProjectHeader>>({
      query: (project) => ({
        url: `/project/projects/`,
        method: 'POST',
        body: project,
      }),
    }),
    updateProject: builder.mutation<ProjectHeader, Partial<ProjectHeader> & { id: number }>({
      query: (project) => ({
        url: `/project/projects/${project.id}/`,
        method: 'PUT',
        body: project,
      }),
    }),
    deleteProject: builder.mutation<void, number>({
      query: (id) => ({
        url: `/project/projects/${id}/`,
        method: 'DELETE',
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProjectsQuery, useGetProjectByIdQuery } = khoziApi